import 'react';
import PropTypes from 'prop-types';
var KEYS = {
  ENTER: 13
};
var REACT_ELEMENT_TYPE;
function _jsx(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
var keyDownFunction = function keyDownFunction(handler) {
  return function (event) {
    return event.keyCode === KEYS.ENTER && handler(event);
  };
};
var Clickable = function Clickable(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    title = _ref.title,
    children = _ref.children,
    name = _ref.name;
  var onKeyDown = keyDownFunction(onClick);
  return /*#__PURE__*/_jsx("button", {
    name: name,
    className: "mshops-web-components-clickable ".concat(className),
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    title: title
  }, void 0, children);
};
Clickable.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired
};
Clickable.defaultProps = {
  name: '',
  className: '',
  onMouseEnter: null,
  onMouseLeave: null,
  title: ''
};
var Clickable$1 = Clickable;
export { Clickable$1 as Clickable, Clickable$1 as default };
